"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.updateDealStages = updateDealStages;
exports.createPipeline = createPipeline;
exports.deletePipeline = deletePipeline;
exports.bulkUpdateDealStages = bulkUpdateDealStages;
exports.reorderPipelines = reorderPipelines;

var LocalSettings = _interopRequireWildcard(require("crm_data/settings/LocalSettings"));

var _immutable = require("immutable");

var _LocalSettingsKeys = require("crm_data/settings/LocalSettingsKeys");

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _HTTPVerbs = require("crm_data/constants/HTTPVerbs");

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var _MetaAPI = require("crm_data/meta/MetaAPI");

var _MetaProducers = require("crm_data/meta/MetaProducers");

var _propertyTranslator = require("property-translator/propertyTranslator");

var BASE_URL = 'deals/v1';
var UPDATE_STAGE_URI = BASE_URL + "/propertyupdates/multi/dealstage";
var ORDER_API = BASE_URL + "/pipelines/order";

var uri = function uri() {
  var pipelineId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return BASE_URL + "/pipelines/" + pipelineId;
};

var hoistMetadata = function hoistMetadata(stage) {
  return stage.has('metadata') ? stage.merge(stage.get('metadata')) : stage;
};

var getPipelineStageOptions = function getPipelineStageOptions(pipeline) {
  return pipeline.get('stages').map(function (stage) {
    return stage.merge({
      value: stage.get('stageId'),
      text: (0, _propertyTranslator.propertyLabelTranslator)(stage.get('label'))
    });
  }).map(hoistMetadata);
};

var parsePipelines = function parsePipelines(pipelines) {
  var pipelinesMap = pipelines.reduce(function (acc, pipeline) {
    pipeline = pipeline.merge({
      stageOptions: getPipelineStageOptions(pipeline),
      value: pipeline.get('pipelineId'),
      stages: pipeline.get('stages').map(hoistMetadata)
    });
    return acc.set(pipeline.get('pipelineId'), pipeline);
  }, (0, _immutable.Map)()); // Ensure the pipelineId in localSettings still exists

  var defaultPipelineId = LocalSettings.getFrom(localStorage, _LocalSettingsKeys.DEFAULT_PIPELINE_ID);

  if (defaultPipelineId && !pipelinesMap.has(defaultPipelineId)) {
    LocalSettings.deleteFrom(localStorage, _LocalSettingsKeys.DEFAULT_PIPELINE_ID);
  }

  return pipelinesMap.sortBy(function (pipeline) {
    return pipeline.get('displayOrder');
  });
};

function fetch() {
  var fallback = function fallback() {
    return (0, _ImmutableAPI.get)(uri());
  };

  return (0, _MetaAPI.queueFetch)(_MetaProducers.DEAL_PIPELINES, fallback, {}, parsePipelines);
}

function updateDealStages(pipeline) {
  return (0, _ImmutableAPI.put)(uri(pipeline.pipelineId), pipeline);
}

function createPipeline(pipeline) {
  return (0, _ImmutableAPI.post)(uri(), pipeline);
}

function deletePipeline(pipelineId) {
  return (0, _ImmutableAPI.del)(uri(pipelineId));
}

function bulkUpdateDealStages(deltas) {
  // Deltas should look like
  // [{"newValue":"newValue","oldValue":"oldValue"}]
  var options = {
    type: _HTTPVerbs.POST,
    headers: {
      'X-Properties-Source': _PropertySourceTypes.CONTACTS,
      'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
    }
  };
  return (0, _ImmutableAPI.send)(options, UPDATE_STAGE_URI, deltas);
}

function reorderPipelines(pipelines) {
  return (0, _ImmutableAPI.put)(ORDER_API, pipelines);
}